'use client'

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import { FAQ } from '~/lib/sanity.queries'

interface Props {
  faq: FAQ
}

function PageBuilderFaq({ faq }: Props) {
  const [open, setOpen] = useState(false)
  return (
    <Collapsible onOpenChange={setOpen}>
      <CollapsibleTrigger className="w-full text-left flex items-center">
        <span className="flex-1">{faq.question}</span>
        {open ? <ChevronUp /> : <ChevronDown />}
      </CollapsibleTrigger>
      <CollapsibleContent>{faq.answer}</CollapsibleContent>
    </Collapsible>
  )
}

export default PageBuilderFaq
